import { create } from 'zustand'

/**
 * A generation the server refused outright — domain spend cap today, any future
 * hard 402 block tomorrow. Distinct from {@link useInsufficientCreditsStore}:
 * there is no shortfall to top up, so the only useful response is reading the
 * reason and (usually) upgrading the plan.
 */
interface GenerationBlockedState {
  open: boolean
  /** Server-supplied explanation. Already user-facing copy — render as-is. */
  message: string
  /** Server error code, when it sent one. Decides which remedy the dialog offers. */
  code?: string
  /**
   * Server's explicit verdict on whether a plan change clears this refusal.
   * Undefined means it didn't say, and the code alone decides. `false` vetoes
   * the upgrade action — e.g. a collaborator on a project billed to its owner,
   * whose own plan has no bearing on the cap.
   */
  canUpgrade?: boolean
  trigger: (message: string, code?: string, opts?: { canUpgrade?: boolean }) => void
  close: () => void
}

export const useGenerationBlockedStore = create<GenerationBlockedState>(set => ({
  open: false,
  message: '',
  code: undefined,
  canUpgrade: undefined,
  trigger: (message, code, opts) => set({ open: true, message, code, canUpgrade: opts?.canUpgrade }),
  close: () => set({ open: false }),
}))
